/* ══════════════════════════════════════════════════════════════════════════
   AM26 — sertare cu semantică de dialog + anunțarea rezultatelor de filtrare
   ══════════════════════════════════════════════════════════════════════════
   Audit Tier 1 / Tier 2 din 2026-09-04, constatările T1-012 și T1-013.

   ─── 1. FOCUSUL NU INTRĂ ÎN SERTARUL DE COȘ (T1-012) ─────────────────────

   Tema ÎNCEARCĂ deja asta, în `custom-async.js` (openPanel):

       setTimeout(function () {
         el.querySelector('a, input, button, select, textarea, [role="button"]').focus();
       }, 100);

   Codul e mort pentru sertarele umplute prin AJAX, din DOUĂ motive măsurate pe
   DEV 200390115663:

     (a) cu sertarul închis, `#cart` are 0 copii și 0 octeți de innerHTML —
         învelișul din `side-cart-container.liquid` e gol până când conținutul
         e adus prin rețea. La 100 ms `querySelector` întoarce `null`, iar
         `.focus()` pe `null` aruncă TypeError. Întârzierea fixă nu se repară
         mărind-o: depinde de rețea.

     (b) chiar dacă ar găsi ceva, tema își dezactivează singură sertarul —
         vezi comentariul de la `restoreTabOrder`: `negTabIn` e programat la
         500 ms pe TOATE panourile, inclusiv pe cel care se deschide, și
         suprascrie `posTabIn`-ul sincron. După deschidere, cele 12 controale
         din coș aveau toate `tabindex="-1"`.

   Aici așteptăm CONȚINUTUL, nu ceasul: un MutationObserver pe fiecare panou;
   când panoul e deschis (`.toggle`) și primește primul element focusabil,
   mutăm focusul o singură dată. Nu atingem `custom-async.js`: handlerul temei
   rămâne, doar că nu mai e singurul.

   ─── 2. NUMELE ACCESIBIL AL QUICKSHOP-ULUI ───────────────────────────────

   Coșul și disponibilitatea în showroom au titluri statice, puse în Liquid
   prin `aria-label` (vezi containerele). Quickshop-ul NU: titlul lui e numele
   produsului, injectat la deschidere. Îl legăm după încărcare, prin
   `aria-labelledby` către titlul real — fără text românesc fix, care ar rupe
   .bg.

   ─── 3. FILTRAREA NU ANUNȚĂ NIMIC (T1-013) ──────────────────────────────

   Măsurat pe DEV: `document.querySelectorAll('[aria-live]').length === 0` pe
   pagina de colecție. Filtrarea schimbă grila prin AJAX, deci un utilizator de
   cititor de ecran nu află nici că s-a întâmplat ceva, nici câte rezultate au
   rămas. Punem o regiune `polite` care oglindește contorul de rezultate.

   `polite`, nu `assertive`: filtrarea nu e o urgență și nu trebuie să
   întrerupă ce citește utilizatorul în acel moment.
   ─── 4. SEMANTICA DE DIALOG: TRAP, ESCAPE, `inert` (T1-012, partea a doua) ─

   Partea 1 de mai sus rezolvă INTRAREA focusului. Nu rezolvă nimic din ce
   urmează după: măsurat pe DEV cu taste REALE, cu coșul deschis —

     • Tab scăpa în fundal după 5 opriri (a 6-a ajungea pe
       `a.overlay-close-clipping`);
     • 385 de controale din pagina de fundal rămâneau tabulabile;
     • Escape nu închidea nimic;
     • filtrul (`form#filter`) n-avea nici `role`, nici nume accesibil, cu 64
       de controale înăuntru.

   DE CE AICI, ȘI NU ÎNTR-UN FIȘIER NOU. Prima încercare a fost exact asta —
   `assets/am-dialog-a11y.js`, încărcat cu `<script defer>` la finalul lui
   <body>. Fișierul se descarcă (HTTP 200, corp corect, `new Function()` îl
   parsează), dar IIFE-ul NU se evaluează niciodată: `aria-modal` rămâne null,
   observatorul nu există, iar o mutație forțată pe `#cart` nu declanșează
   nimic. Același URL injectat ca tag nou la runtime rulează instantaneu și
   corect (`aria-modal="true"`, `inert` 10 → 32). Cauza n-a fost izolată;
   excluse: tag lipsă, 404, eroare de sintaxă, CSP, cache vechi (copia din
   cache e identică octet cu octet cu cea proaspătă), condiții de poartă
   neîndeplinite. Fișierul acela e ȘTERS — logica trăiește aici, în scriptul
   despre care avem dovadă că rulează (`tabindex="-1"` = 0 pe cele 6 controale
   din coș, deci `restoreTabOrder` chiar s-a executat).

   MODELUL DE PANOURI, CORECTAT PRIN MĂSURARE. Prima versiune avea un tabel cu
   un singur sertar, `#cart`. Pe pagina reală există PATRU panouri `.m6pn` —
   `#login`, `#cart`, `#quickshop`, `#pickup-availability` — plus două care nu
   sunt `.m6pn` deloc: `form#filter.f8fl` și `nav#nav.s1hd`, ambele deschise
   prin `:target`. De aceea reutilizăm aici bucla `.m6pn` de la punctul 1 (le
   prinde pe toate patru, fără listă de întreținut) și tratăm separat exact
   cele două excepții.

   Ambele excepții sunt `visibility: hidden` când sunt închise, dar au
   dimensiuni NENULE (filtrul 298×1514, meniul 360×812). O detecție pe
   dimensiuni ar fi raportat „deschis" permanent; de aceea `esteVizibil` se
   uită la `visibility`/`display`, nu la dreptunghi.

   DE CE `aria-modal` SE PUNE ABIA ACUM. Comentariul din
   `side-cart-container.liquid` explică de ce fusese scos: fără focus trap
   real, `aria-modal="true"` MINTE cititorul de ecran, spunându-i că restul
   paginii e inaccesibil când de fapt e perfect tabulabil. Acum că trap-ul
   există, atributul devine adevărat — dar se pune și se scoate DINAMIC, doar
   cât timp sertarul e deschis.

   PRINCIPIU: nu deschidem și nu închidem nimic singuri. Tema controlează în
   continuare deschiderea (clase, hash, AJAX); noi doar OBSERVĂM starea și
   adăugăm comportamentul de tastatură. Așa nu ne batem cu `custom-async.js`.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // NU excludem `[tabindex="-1"]` aici: vezi mai jos — tema stampileaza -1 pe
  // TOT continutul sertarului la 500 ms dupa deschidere, deci un selector care
  // sare peste -1 nu ar gasi nimic exact in sertarul deschis.
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [role="button"]';

  /* ── BUG-UL DE TABINDEX AL TEMEI ──────────────────────────────────────────
     In `openPanel` (custom-async.js:2235-2251) tema face, in ordinea asta:

       Array.from(module_panel).forEach(...)   // TOATE panourile
         setTimeout(function () { negTabIn(el); }, 500);   // -> tabindex="-1"

       linked.forEach(...)                     // panoul care SE DESCHIDE
         posTabIn(el);                         // -> tabindex="" (sincron)

     `negTabIn` e programat si pe panoul care tocmai se deschide, fiindca bucla
     merge pe `module_panel` (toate), nu pe cele care se inchid. `posTabIn`
     ruleaza sincron, deci PRIMUL; temporizatorul de 500 ms vine DUPA si pune
     `tabindex="-1"` inapoi pe sertarul deja deschis.

     Masurat pe DEV dupa deschiderea cosului: 12 controale focusabile, toate cu
     `tabindex="-1"`. Sertarul e deschis, vizibil, si complet inaccesibil din
     Tab. Nu atingem `custom-async.js`; reparam starea dupa ce temporizatorul
     temei si-a facut treaba.
     ───────────────────────────────────────────────────────────────────────── */

  function restoreTabOrder(panel) {
    Array.prototype.forEach.call(panel.querySelectorAll('[tabindex="-1"]'), function (el) {
      // Doar controalele reale; nu atingem ce a fost -1 din alt motiv
      // (ex. un element scos deliberat din parcurs de alt cod al nostru).
      if (el.matches(FOCUSABLE)) { el.removeAttribute('tabindex'); }
    });
  }

  function firstFocusable(panel) {
    var list = panel.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) { return list[i]; }
    }
    return null;
  }

  function nameQuickshop(panel) {
    if (panel.id !== 'quickshop') { return; }
    if (panel.getAttribute('aria-labelledby')) { return; }
    var heading = panel.querySelector('h1, h2, h3');
    if (!heading) { return; }
    if (!heading.id) { heading.id = 'am-quickshop-title'; }
    panel.setAttribute('aria-labelledby', heading.id);
  }

  function watchPanel(panel) {
    var handledOpen = false;

    function settle() {
      if (!panel.classList.contains('toggle')) { handledOpen = false; return; }
      nameQuickshop(panel);
      if (handledOpen) { return; }
      var target = firstFocusable(panel);
      if (!target) { return; }            // continutul inca nu a sosit
      handledOpen = true;
      restoreTabOrder(panel);
      if (!panel.contains(document.activeElement)) { target.focus(); }
      // Dupa temporizatorul de 500 ms al temei, refacem parcursul si, daca
      // focusul a fost pierdut intre timp, il readucem in sertar.
      setTimeout(function () {
        if (!panel.classList.contains('toggle')) { return; }
        restoreTabOrder(panel);
        if (!panel.contains(document.activeElement)) {
          var t2 = firstFocusable(panel);
          if (t2) { t2.focus(); }
        }
      }, 650);
    }

    try {
      new MutationObserver(settle).observe(panel, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
    } catch (e) { /* fara observer, ramane comportamentul temei */ }
    settle();
  }

  /* ══ 4. Semantică de dialog: trap, Escape, `inert` pe fundal ══════════════
     Vezi antetul pentru context și pentru istoricul fișierului separat. */

  // Aici EXCLUDEM `[tabindex="-1"]`: spre deosebire de FOCUSABLE de mai sus,
  // lista asta descrie ce poate primi focus ACUM, pentru trap. `restoreTabOrder`
  // a curățat deja -1-urile puse de temă până când ajungem să tabulăm.
  var TABABILE = [
    'a[href]', 'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function esteVizibil(el) {
    if (!el) { return false; }
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) { return false; }
    var st = window.getComputedStyle(el);
    return st.visibility !== 'hidden' && st.display !== 'none';
  }

  function tababile(root) {
    return Array.prototype.filter.call(root.querySelectorAll(TABABILE), esteVizibil);
  }

  /* Cele două sertare care NU sunt `.m6pn`.

     SELECTORUL FILTRULUI, CORECTAT PRIN MĂSURARE. Prima versiune ținea
     `form#filter`. Greșit: regula temei care face sertarul vizibil este

         .f8fl-open #root .m6cl > aside { visibility: visible; opacity: 1; }

     deci elementul-dialog e `<aside>`-ul, iar `form#filter` e doar conținutul
     lui. Măsurat pe /collections/boxe-pasive la 375px, cu filtrul deschis:
     aside 330×812 cu 98 de controale, form#filter 298×1115 — mai ÎNALT decât
     ecranul, fiindcă e conținutul derulabil. Un trap pus pe formular ar fi
     lăsat pe dinafară controlul de închidere al aside-ului.

     Starea „deschis" e clasa `f8fl-open` de pe <html>, NU `:target`: am
     verificat că o navigare la `#filter` lasă panoul închis. Păstrăm totuși
     verificarea de vizibilitate, fiindcă tranziția durează 0,4 s și clasa
     apare înaintea ei.

     Doar pe mobil: pe desktop filtrul e o coloană permanentă din pagină, iar
     transformarea lui în dialog ar fi o regresie. */
  var SPECIALE = [
    {
      sel: '#root .m6cl > aside',
      ceruta: 'f8fl-open',                 // clasă pe <html>
      inchide: '.f8fl-toggle, .f8fl-close, #root > .overlay-close',
      numeImplicit: 'Filtre'
    },
    {
      sel: 'nav#nav.s1hd',
      ceruta: null,
      inchide: '.s1hd-close, .am-nav-close, a[href="#nav"]',
      numeImplicit: null
    }
  ];

  var activ = null; // { el, inchide, aInert: [], focusAnterior }

  /* Fundalul = frații sertarului la FIECARE nivel, urcând până la <body>.
     `inert` scoate tot subarborele din ordinea de tabulare ȘI din arborele de
     accesibilitate — de aceea e preferabil unui `tabindex=-1` pus pe fiecare
     control (386 de noduri de atins și de pus la loc, cu risc să stricăm
     `tabindex`-uri existente).

     BUG PRINS LA PRIMA MĂSURĂTOARE: prima versiune se uita DOAR la copiii lui
     <body>. Dar `#cart` nu e copil de <body> — lanțul real e
     `#cart → #root → BODY`, deci exact învelișul `#root`, cu cele 385 de
     controale, era sărit. Rezultat măsurat: 10 noduri `inert` pe
     noscript/shopify-store și fundalul rămânea integral tabulabil. De aceea
     urcăm nivel cu nivel: la fiecare părinte marcăm frații, nu și părintele. */
  function fundal(el) {
    var out = [];
    var n = el;
    while (n && n !== document.body && n.parentElement) {
      var p = n.parentElement;
      Array.prototype.forEach.call(p.children, function (frate) {
        if (frate === n || frate.nodeType !== 1) { return; }
        var t = frate.tagName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'LINK' || t === 'NOSCRIPT') { return; }
        out.push(frate);
      });
      n = p;
    }
    return out;
  }

  function numeste(el, implicit) {
    if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) { return; }
    var t = el.querySelector('h1, h2, h3, legend, [class*="title"]');
    if (t && (t.textContent || '').trim()) {
      if (!t.id) { t.id = 'am-dlg-titlu-' + Math.random().toString(36).slice(2, 8); }
      el.setAttribute('aria-labelledby', t.id);
      return;
    }
    // Ultimă soluție. Text românesc fix ar rupe .bg, deci îl folosim DOAR dacă
    // panoul n-are absolut niciun titlu din care să derivăm numele.
    if (implicit) { el.setAttribute('aria-label', implicit); }
  }

  function porneste(el, inchide, numeImplicit) {
    if (activ && activ.el === el) { return; }
    if (activ) { opreste(); }

    var focusAnterior = document.activeElement;

    // Doar unde lipsește — nu suprascriem ce a pus tema (coșul are deja
    // role="dialog" și aria-label din Liquid).
    if (!el.getAttribute('role')) { el.setAttribute('role', 'dialog'); }
    numeste(el, numeImplicit);
    // Adevărat abia acum: trap-ul de mai jos chiar face fundalul inaccesibil.
    el.setAttribute('aria-modal', 'true');

    var aInert = [];
    fundal(el).forEach(function (n) {
      if (!n.hasAttribute('inert')) { n.setAttribute('inert', ''); aInert.push(n); }
    });

    activ = { el: el, inchide: inchide, aInert: aInert, focusAnterior: focusAnterior };

    // Focusul în sertar doar dacă nu e deja acolo: pentru `.m6pn`, `watchPanel`
    // de mai sus l-a mutat deja, și nu vrem să-l smulgem de acolo.
    if (!el.contains(document.activeElement)) {
      var f = tababile(el);
      var tinta = f[0] || el;
      if (tinta === el && !el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '-1'); }
      try { tinta.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    }
  }

  function opreste() {
    if (!activ) { return; }
    var a = activ;
    activ = null;
    a.el.removeAttribute('aria-modal');
    a.aInert.forEach(function (n) { n.removeAttribute('inert'); });
    // Focusul se întoarce de unde a plecat — cerință APG, și singurul mod în
    // care un utilizator de tastatură nu se trezește la începutul paginii.
    if (a.focusAnterior && document.contains(a.focusAnterior) && esteVizibil(a.focusAnterior)) {
      try { a.focusAnterior.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    }
  }

  function inchideSertarul(a) {
    // Nu închidem noi: apăsăm controlul de închidere al TEMEI, ca să rămână o
    // singură sursă de adevăr pentru starea sertarului.
    if (!a.inchide) { return false; }
    var btn = a.el.querySelector(a.inchide) || document.querySelector(a.inchide);
    if (btn) { btn.click(); return true; }
    return false;
  }

  function laTasta(ev) {
    if (!activ) { return; }

    if (ev.key === 'Escape' || ev.key === 'Esc') {
      var inchis = inchideSertarul(activ);
      opreste();
      if (inchis) { ev.preventDefault(); }
      return;
    }

    if (ev.key !== 'Tab') { return; }
    var f = tababile(activ.el);
    if (!f.length) { ev.preventDefault(); return; }
    var primul = f[0], ultimul = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === primul) {
      ev.preventDefault(); ultimul.focus();
    } else if (!ev.shiftKey && document.activeElement === ultimul) {
      ev.preventDefault(); primul.focus();
    } else if (!activ.el.contains(document.activeElement)) {
      // Focusul a scăpat deja (click în fundal, script străin): îl aducem înapoi.
      ev.preventDefault(); primul.focus();
    }
  }

  function scaneaza() {
    var gasit = null;

    // (a) Panourile `.m6pn` — aceleași patru pe care le urmărește punctul 1.
    var panouri = document.querySelectorAll('.m6pn');
    for (var i = 0; i < panouri.length && !gasit; i++) {
      var pn = panouri[i];
      // `.toggle` e semnalul temei; cerem și conținut, fiindcă învelișul e gol
      // până când AJAX-ul aduce ce trebuie, iar un dialog gol n-are ce captura.
      if (pn.classList.contains('toggle') && pn.children.length > 0 && esteVizibil(pn)) {
        gasit = { el: pn, inchide: '.m6pn-close', nume: null };
      }
    }

    // (b) Cele două excepții, doar pe mobil.
    if (!gasit && window.innerWidth < 1024) {
      for (var j = 0; j < SPECIALE.length && !gasit; j++) {
        var d = SPECIALE[j];
        if (d.ceruta && !document.documentElement.classList.contains(d.ceruta)) { continue; }
        var el = document.querySelector(d.sel);
        if (el && esteVizibil(el)) {
          gasit = { el: el, inchide: d.inchide, nume: d.numeImplicit };
        }
      }
    }

    if (gasit) { porneste(gasit.el, gasit.inchide, gasit.nume); }
    else if (activ) { opreste(); }
  }

  var programat = false;
  function planifica() {
    if (programat) { return; }
    programat = true;
    window.requestAnimationFrame(function () { programat = false; scaneaza(); });
  }

  function initDialog() {
    document.addEventListener('keydown', laTasta, true);

    /* Observăm <html>, nu <body>: sertarul de coș e injectat prin AJAX, iar un
       observator pe <body> nu reacționa la schimbarea lui `aria-hidden` —
       nodul observat ajungea să fie înlocuit. `documentElement` nu e niciodată
       înlocuit, deci observatorul supraviețuiește. */
    try {
      new MutationObserver(planifica).observe(document.documentElement, {
        subtree: true, attributes: true, childList: true,
        attributeFilter: ['aria-hidden', 'class', 'style', 'open']
      });
    } catch (e) { /* fără observer rămâne comportamentul temei */ }

    window.addEventListener('hashchange', planifica);
    window.addEventListener('resize', planifica);
    /* Plasă de siguranță: orice click poate deschide un sertar, iar unele căi
       (`:target` pe filtru și pe meniu) nu produc mutații de atribut. */
    document.addEventListener('click', function () { setTimeout(planifica, 60); }, true);
    document.addEventListener('focusin', planifica, true);

    scaneaza();
  }

  function initPanels() {
    Array.prototype.forEach.call(document.querySelectorAll('.m6pn'), watchPanel);
  }

  /* ── 3. Regiunea live pentru filtrare ─────────────────────────────────── */

  // MĂSURAT pe DEV 200390115663, /collections/boxe-pasive:
  //   • grila e `ul#collection.l4cl` cu 413 `<li>` copii direcți;
  //   • contorul e un `<h2>` FĂRĂ clasă, cu textul „413 produse".
  // Primele variante ale acestui fișier ținteau `.f8fl-count` / `.l4pr` —
  // zero potriviri pe pagina reală, deci scriptul ar fi tăcut complet. De aici
  // regula: selectorii se confirmă în pagină înainte de a fi scriși.
  //
  // Observatorul NU se leagă de grilă: filtrarea face
  // `collectionSection.innerHTML = …` (custom-async.js:5740), deci `ul#collection`
  // e distrus și recreat la fiecare filtrare, iar un observator pe el ar muri
  // după primul swap. Ne legăm de secțiunea Shopify, care supraviețuiește.

  function findGrid() {
    return document.getElementById('collection');
  }

  function findCounter() {
    var scope = document.querySelector('.collection-wrapper') || document;
    var hs = scope.querySelectorAll('h1, h2, h3');
    for (var i = 0; i < hs.length; i++) {
      var t = (hs[i].textContent || '').trim();
      // „413 produse", „1 produs", „24 rezultate"
      if (/^[\d][\d.\u00a0\s]*\s*(produse|produs|rezultate|rezultat)\b/i.test(t)) {
        return hs[i];
      }
    }
    return null;
  }

  function initLiveRegion() {
    var grid = findGrid();
    if (!grid) { return; }

    var section = grid.closest('.shopify-section') || grid.parentNode;

    var region = document.getElementById('am-filter-status');
    if (!region) {
      region = document.createElement('p');
      region.id = 'am-filter-status';
      region.className = 'am-sr-only';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      region.setAttribute('role', 'status');
      // În AFARA secțiunii care e rescrisă, altfel swap-ul ar șterge regiunea
      // exact în momentul în care trebuie să anunțe.
      section.parentNode.insertBefore(region, section);
    }

    var last = '';
    var timer = null;

    function announce() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var counter = findCounter();
        var text = counter ? (counter.textContent || '').trim().replace(/\s+/g, ' ') : '';
        if (!text) {
          var g = findGrid();
          if (!g) { return; }
          var n = g.querySelectorAll(':scope > li').length;
          if (!n) { return; }
          text = n + '';
        }
        if (text === last) { return; }
        last = text;
        region.textContent = text;
      }, 350);
    }

    // Prima valoare e starea inițială a paginii: o reținem fără s-o anunțăm,
    // ca cititorul de ecran să nu primească un mesaj la simpla încărcare.
    var c0 = findCounter();
    last = c0 ? (c0.textContent || '').trim().replace(/\s+/g, ' ') : '';

    try {
      new MutationObserver(announce).observe(section, { childList: true, subtree: true });
    } catch (e) { /* fără observer nu anunțăm — dar nu stricăm nimic */ }
  }

  function init() { initPanels(); initLiveRegion(); initDialog(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
